import { render, staticRenderFns } from "./PolymorphicReferenceCreate.vue?vue&type=template&id=1c6340ec&"
import script from "./PolymorphicReferenceCreate.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceCreate.vue?vue&type=script&lang=js&"
import style0 from "./PolymorphicReferenceCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports